import React from 'react'
import { Link } from 'react-router-dom'
import '../styles.css'
import AppBar from '../components/AppBar.js'

function Refresh() {
    return (
        <div className='column'>
            <AppBar displayText='Sign In Error' />
            <b className='titleText' style={{ marginTop: 30, fontSize: 20 }}>You have been signed out</b>
            <b className='titleText' style={{ fontSize: 20 }}>Please sign in</b>
            <div className='submitArea'>
                <Link to='/' className='signupFormSubmitButton' style={{ textDecoration: 'none' }}>Click me!</Link>
            </div>
        </div>
    )
}

export default Refresh
